import { render, staticRenderFns } from "./PurchaseCreditsModal.vue?vue&type=template&id=6632e338&scoped=true"
import script from "./PurchaseCreditsModal.vue?vue&type=script&lang=js"
export * from "./PurchaseCreditsModal.vue?vue&type=script&lang=js"
import style0 from "./PurchaseCreditsModal.vue?vue&type=style&index=0&id=6632e338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6632e338",
  null
  
)

export default component.exports